import CakeChartComponent from './CakeChart/CakeChart'
import ClientCardComponent from './ClientCard/ClientCard'
import ContentComponent from './Content/Content'
import ContentTopBarComponent from './ContentTopBar/ContentTopBar'
import FiltersComponent from './Filters/Filters'
import SidebarComponent from './Sidebar/Sidebar'
import TableHeadersComponent from './TableHeaders/TableHeaders'
import ModalClientComponent from './ModalClient/ModalClient'
import ModalRiskComponent from './ModalRisk/ModalRisk'
import ModalUbosComponent from './ModalUbos/ModalUbos'
import AdvancedTabsComponent from './AdvancedTabs/AdvancedTabs'
import ModalRequestOptComponent from './ModalRequestOpt/ModalRequestOpt'
import ModalClientCardComponent from './ModalClientCard/ModalClientCard'
import ModalRecordComponent from './ModalClientCard/ModalRecord'

export const CakeChart = CakeChartComponent
export const ClientCard = ClientCardComponent
export const Content = ContentComponent
export const ContentTopBar = ContentTopBarComponent
export const Filters = FiltersComponent
export const Sidebar = SidebarComponent
export const TableHeaders = TableHeadersComponent
export const ModalClient = ModalClientComponent
export const ModalRisk = ModalRiskComponent
export const ModalUbos = ModalUbosComponent
export const AdvancedTabs = AdvancedTabsComponent
export const ModalRequestOpt = ModalRequestOptComponent
export const ModalClientCard = ModalClientCardComponent
export const ModalRecord = ModalRecordComponent